export enum HRRAExceptionCode {
  Unspecified = 1,
  MalformedUserAuthenticationToken = 2,
  UserDoesNotExist = 3,
  SessionExpired = 4,
  SessionDoesNotExist = 5,
  AttemptOfUnauthorizedAccess = 6,
  UserDoesNotHavePermissionForTheFeatureRequested = 7,
  UserDoesnotHavePermissionForTheResourceRequested = 8,
  OnlyCustomerSSOSupported = 9,
  NonExistentResourceRequested = 10,
  AccountInModeration = 11,
  PendingJobseekerLoginRequest = 12,
  DataExpired = 13,
  CustomerIdNumberExists = 14,
  CvDatabaseAccessTokenRequestAlreadyProcessed = 15,
  SliderBannerRequestAlreadyProcessed = 16,
  CvBoxAccessTokenRequestAlreadyProcessed = 17,
  InvalidData = 18,
  CustomerNotInPortfolio = 19,
  CustomerNoBillingInfo = 20,
  TransactionRequestPayerPortfolioAccountManagerMismatch = 21,
  CustomerSigninAttemptOnWrongWebsite = 22,
  PendingUpgradeExists = 23,
  ActiveOrPendingTokenExists = 24,
  MatchingAlreadyProcessing = 25,
  AlreadyApproved = 26,
  NotAllJobseekersProcessed = 27,
  NoAcceptedJobseekers = 28,
  JobseekerSubscription_MandatoryFieldMissing = 29,
  NotificationDoesNotExist = 30,
  NotificationStatusNotValid = 31,
  NotifiedInPast = 32,
  JobseekerIsInModeration = 33,
  //intenral exceptions
  SubscriberNotFound = 34,
  SubscriberIsNotActiveOrPending = 35,
  HashCodeNotFound = 36,
  InvalidHashcodeType = 37,
  InvalidSubscriberCode = 38,
  CustomerAlreadyHasGotCBvox = 39, //TODO: rename
  InactiveCvBox = 40,
  JobseekerAlreadyApplied = 41,
  CustomerStatusCannotBeUndefined = 42,
  CustomerHasNotLogo = 43,
  JobseekerIsAlreadySaved = 44,
  AnnouncementDistributionChannelsDuplication = 45,
  MatchingListNotEmpty = 46,
  MatchingListEmpty = 47,
  InvalidAnnouncementMatchingJobseekerApproveRequestData = 48,
  AnnouncementLanguageAlreadyExists = 49,
  DeactivatedCustomerCantBeProfileOwner = 50,
  NoExpressApproveableJobseekers = 51,
  JobseekerEducationNotFound = 52,
  JobseekerWorkexperienceNotFound = 53,
  JobseekerLanguageNotFound = 54,
  JobseekerDocumentNotFound = 55,
  JobseekerEducationFileNotFound = 56,
  JobseekerWorkexperienceFileNotFound = 57,
  JobseekerLanguageFileNotFound = 58,
  JobseekerDocumentFileNotFound = 59,
  EmailVerificationTokenInvalid = 60,
  EmailVerificationResendMaxAttemptsExceeded = 61,
  UserAlreadyActivated = 62,
  InputValidationFailed = 63,
  CaptchaInvalid = 64,
  CaptchServiceError = 65,
  AnnouncementNotFound = 66,
  JobseekerCurrentPasswordIsIncorrect = 67,
  SubscriberIsNotActive = 68,
  PasswordMismatch = 69,
  TooManyCustomers = 70,
  NonExistingcustomerInBlacklist = 71,
  UserRegistrationNotFound = 72,
  CustomerInModeration = 73,
  JobseekerPendingModerationPhotoEditIsNotAllowed = 74,
  JobseekerIsNotActive = 75,
  CustomerDoesNotExist = 76,
  CustomerIsNotActive = 77,
  ProfileIsPrivate = 78,
  ProfileIsIncomplete = 79,
  MalformedUploadRequest = 80,
  CustomerIsBlackListed = 81,
  TooManyItemsOnPage = 82,
  InvalidAnnouncement = 83,
  CustomerAgentIndicatedAsContactPersonInActiveAnnouncement = 84,
  RedisTransactionFailure = 85,
  EmailGenerationServiceError = 86,
  ApacheTikaDocumentIndexingServiceError = 87,
  ErrorOccuredWhenAddingAnnouncement = 88,
  SqlConnectionStringNotProvided = 89,
  SqlEmailConnectionStringNotProvided = 90,
  CustomerBrandingAlreadyExists = 91,
  AnnouncementAutoRenewalProductLatePurchase = 92,
  AnnouncementAutoRenewalIncompatibleProductUpgrade = 93,
  PendingAnnouncementInstantRenewalIsNotAllowed = 94,
  NonActiveAnnouncementInstantRenewalIsNotAllowed = 95,
  MoreThanOneInstantRenewalsPerDayIsNotAllowed = 96,
  PendingAnnouncementUpgradeIsNotAllowed = 97,
  AnnouncementInstantRenewalIncompatibleProductUpgrade = 98,
  ProductNotFound = 99,
  FolderNotFound = 100,
  FolderNumberLimitReached = 101,
  InvalidFolderName = 102,
  InvalidEmailAddress = 103,
  InvalidLocation = 104,
  InvalidIndustry = 105,
  InvalidToken = 106,
  JobseekerNotFound = 107,
  ViewingJobseekerNotPermitted = 108,
  EmailIsAlreadyRegistered = 109,
  CustomerDoesNotHaveCvDatabaseAccess = 110,
  ElasticSearchServerError = 111,
  CustomerDoesNotHaveCvBox = 112,
  CvDatabaseOrderDoesNotHaveDatabaseTokenId = 113,
  CvDatabaseProductDoesNotFind = 114,
  CustomerReachedDemoLimitCvDatabaseAccess = 115,
  CustomerDoesNotHaveBranding = 116,
  CustomerBrandingAccessTokenRequestAlreadyProcessed = 117,
  OnlyActiveCustomerBrandingAccessTokenCanBeTerminated = 118,
  ActiveOrPendigCustomerBrandingAccessTokenExists = 119,
  AnnouncementDetailsDesktopBgImageSizeIsTooLarge = 120,
  AnnouncementDetailsMobileBgImageSizeIsTooLarge = 121,
  InvoiceDoesNotFound = 122,
  CustomerFeedDoesNotFound = 123,
  CustomerWidgetDoesNotFound = 124,
  CustomerDoesNotHaveCustomFeed = 125,
  CreateCustomFeedDoesNotAllowed = 126,
  CustomerDoesNotAllowToViewFeed = 127,
  JobseekerAddressesDoesNotMatch = 128,
  LocationDoesNotFound = 129,
  LocationDoestNotHaveParentId = 130,
  AnnouncementExtendedLocationAlreadyExists = 131,
  ProviderWebsiteNotFound = 132,
  AnnouncementDistributedChannelsNotFound = 133,
  TransactionNotFound = 134,
  AdminNotFound = 135,
  AccountManagerNotFound = 136,
  UserNotFound = 137,
  ItemNotFound = 138,
  PendingAnnouncementModerationNotFound = 139,
  AnnouncementModerationNotFound = 140,
  InvalidAnnouncementModerationState = 141,
  AnnouncementModerationUpdateConflict = 142,
  JobseekerModerationNotFound = 143,
  JobseekerModerationUpdateConflict = 144,
  JobseekerDrivingLicenseNotFound = 145,
  JobseekerVehicleTypeNotFound = 146,
  PendingJobseekerModerationNotFound = 147,
  InvalidJobseekerModerationState = 148,
  InvalidResetMapItem = 149,
  RejectingNotPendingAttributeIsNotAllowed = 150,
  CannotRejectAllModeratedFields = 151,
  CustomerNotFound = 152,
  PendingCustomerModerationNotFound = 153,
  BrandingNotFound = 154,
  CustomerModerationUpdateConflict = 155,
  CustomerEditIsNotAllowed = 156,
  InvalidUserStatus = 157,
  PendingCustomerAgentLoginRequest = 158,
  CustomerAgentNotFound = 159,
  IndustryNotFound = 160,
  PortfolioNotFound = 161,
  InvalidCustomerModerationState = 162,
  CustomerModerationNotFound = 163,
  JobseekerAlreadyDeleted = 164,
  CustomerAccountNotFound = 165,
  CustomerAlreadyDeleted = 166,
  CustomerHasBillingHistory = 167,
  CustomerHasDebt = 168,
  CustomerHasActiveCvDatabase = 169,
  CustomerHasActiveCvBox = 170,
  CustomerHasActiveOrPendingSliderBanner = 171,
  CustomerHasActiveJobFair = 172,
  CustomerHasAnnouncements = 173,
  OnlyActiveCustomerCanBeArchived = 174,
  SystemRejectionNotAllowedAfterInitialModeration = 175,
  PortfolioSalesAssistantNotFound = 176,
  PortfolioSalesAssistantAlreadyRemoved = 177,
  PortfolioSalesAssistantAlreadyExists = 178,
  CanNotCreatePortfolioSalesAssistant = 179,
  EntityHashCodeNotFound = 180,
  InvalidEntityHashCodeObjectType = 181,
  UserAlreadyDeleted = 182,
  InvalidActivationRequest = 183,
  AdvancedIndustryCodeNotFound = 184,
  AnnouncementInfoNotFound = 185,
  SpecializationNotFound = 186,
  BenefitNotFound = 187,
  SeniorityLevelNotFound = 188,
  TransportTypeNotFound = 189,
  EducationProgramNotFound = 190,
  EducationLevelNotFound = 191,
  OrderItemMismatchException = 192,
  InvalidPageNumber = 193,
  JobseekerLanguageProficiencyLevelNotFound = 194,
  JobseekerInfoNotFound = 195,
  JobseekerInfoExperienceNotFound = 196,
  JobseekerUpdateFieldsEmpty = 197,
  InvalidWorkExperienceEventType = 198,
  JobseekerIdDoesNotMatch = 199,
  JobseekerEmploymentFormNotFound = 200,
  JobseekerWorkScheduleNotFound = 201,
  InvalidWorkExperienceItem = 202,
  SmsProviderServiceError = 203,
  InvalidSmsProviderParameters = 204,
  JobseekerInfoExperienceFileNotFound = 205,
  EducationInstitutionNotFound = 206,
  InvalidPasswordException = 207,
  ElasticSearchMaxResultExceeded = 208,
  InvalidFeatureFlagName = 209,
  CustomerInfoNotFound = 210,
  LogoRemovalIsNotSupported = 211,
  AdvancedIndustryNotFound = 212,
  GeoRestrictionCountryNotFound = 213,
  CountryContextNotFound = 214,
  VisitorCountryIsRestricted = 215,
  VisitorCountryNotDetected = 216,
  WorkScheduleNotFound = 217,
  CurrentPasswordIsIncorrect = 233,
  OTPInvalidRequest = 234,
  OTPSendingFailed = 235,
  OTPRateLimitExceeded = 236,
  OTPInternalServiceError = 237,
  OTPCodeExpired = 238,
  OTPCodeNotValid = 239,
  OTPCodeAttemptLimitExcceded = 240,
  OTPIvalidConfigurationError = 241,
  OTPTokenNotFound = 242,
  OTPCodeUsed = 243,
  OTPRequestIdMismatch = 244
}